export function mergeOnboardingLocalConfig(existing: unknown, accountType: string, localFields: Record<string, unknown>) {
  const base = existing && typeof existing === "object" && !Array.isArray(existing)
    ? { ...(existing as Record<string, unknown>) }
    : {};
  if (accountType !== "local") return base;
  return { ...base, ...localFields };
}
